module.exports = __webpack_public_path__ + "media/green-circle.52288970.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/standard/green-circle.svg
// module id = 896
// module chunks = 0